import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Navbar, Nav, Button } from 'react-bootstrap'; // JSS

import { Link } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreLink } from '../link/Link';
import { AccountDropdown } from './AccountDropdown';
import MenuItem from './MenuItem';

var checkActive = function checkActive(url) {
  if (typeof window === 'undefined') {
    return false;
  }

  var currentUrl = window.location.href;
  var check = typeof currentUrl.includes === 'function' ? currentUrl.includes(url) : false;
  return typeof currentUrl.includes === 'function' ? currentUrl.includes(url) : false;
};

var Menu = function Menu(_ref) {
  var items = _ref.items,
      handleLogin = _ref.handleLogin,
      handleAccoount = _ref.handleAccoount,
      authenticationState = _ref.authenticationState,
      accountInfo = _ref.accountInfo,
      isCnbSite = _ref.isCnbSite;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeMain = _useState2[0],
      setActiveMain = _useState2[1];

  return /*#__PURE__*/React.createElement(Navbar, {
    className: "cb-menu navbar navbar-default"
  }, /*#__PURE__*/React.createElement(Nav, {
    className: "nav mr-auto cb-menu__nav",
    as: "ul",
    role: "menu"
  }, items.map(function (item, index) {
    var _item$navigationTitle, _item$navigationTitle2, _item$externalUrl, _item$navigationTitle3, _item$navigationTitle4, _item$navigationTitle5, _item$externalUrl2, _item$children, _item$navigationTitle6;

    var model = {
      navigationTitle: (_item$navigationTitle = item.navigationTitle) === null || _item$navigationTitle === void 0 ? void 0 : _item$navigationTitle.value,
      value: {
        href: ((_item$navigationTitle2 = item.navigationTitle) === null || _item$navigationTitle2 === void 0 ? void 0 : _item$navigationTitle2.value) !== 'Shop' ? item.url : (_item$externalUrl = item.externalUrl) === null || _item$externalUrl === void 0 ? void 0 : _item$externalUrl.value,
        title: (_item$navigationTitle3 = item.navigationTitle) === null || _item$navigationTitle3 === void 0 ? void 0 : _item$navigationTitle3.value,
        text: (_item$navigationTitle4 = item.navigationTitle) === null || _item$navigationTitle4 === void 0 ? void 0 : _item$navigationTitle4.value
      },
      chidlren: item.children
    };
    var itemUrl = ((_item$navigationTitle5 = item.navigationTitle) === null || _item$navigationTitle5 === void 0 ? void 0 : _item$navigationTitle5.value) !== 'Shop' ? item.url : (_item$externalUrl2 = item.externalUrl) === null || _item$externalUrl2 === void 0 ? void 0 : _item$externalUrl2.value;
    var isActive = checkActive(itemUrl);
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(Nav.Item, {
      as: "li",
      className: "dropdown cb-menu__dropdown-trigger"
    }, ((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) > 0 && ((_item$navigationTitle6 = item.navigationTitle) === null || _item$navigationTitle6 === void 0 ? void 0 : _item$navigationTitle6.value) !== 'Shop' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItem, {
      item: item,
      index: index,
      active: isActive,
      activeMain: activeMain,
      setActiveMain: setActiveMain
    }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SitecoreLink, {
      className: "\n                    ".concat(isActive ? 'is-current' : '', "\n                    "),
      field: model
    }))));
  }), !isCnbSite && /*#__PURE__*/React.createElement(Nav.Item, {
    as: "li",
    className: "cb-menu__dropdown-trigger cb-menu__sign-in d-flex d-sm-none cb-header__mobiledisplay"
  }, authenticationState !== 'Authenticated' ? /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick(e) {
      return handleLogin();
    },
    className: "cb-button-unstyled"
  }, "Sign In") : /*#__PURE__*/React.createElement(AccountDropdown, {
    handleAccoount: handleAccoount,
    authenticationState: authenticationState,
    accountInfo: accountInfo
  }))));
};

export default Menu;